export const admin = {
    title: 'FSD Admin',
    header: {
        title: 'Panel Administrativo',
        toggleMenu: 'Alternar menú',
    },
    nav: {
        dashboard: 'Dashboard',
        newDrones: 'Drones Nuevos',
        usedDrones: 'Drones Usados',
        buffalo: 'Línea Buffalo',
        powerCitros: 'Power Citros',
        parts: 'Piezas y Accesorios',
    },
    dashboard: {
        title: 'Dashboard',
        description: 'Bienvenido al panel administrativo de Fronteira Sul Drones',
        stats: {
            totalNewDrones: 'Drones Nuevos',
            totalUsedDrones: 'Drones Usados',
            totalBuffalo: 'Línea Buffalo',
            totalPowerCitros: 'Power Citros',
            totalParts: 'Piezas y Accesorios',
        },
    },
    newDrones: {
        title: 'Drones Nuevos',
        description: 'Gestionar los drones nuevos en el sistema',
        empty: 'No hay drones nuevos registrados. Haga clic en "Agregar Drone" para comenzar.',
        addButton: 'Agregar Drone',
    },
    usedDrones: {
        title: 'Drones Usados',
        description: 'Gestionar los drones usados en el sistema',
        empty: 'No hay drones usados registrados. Haga clic en "Agregar Drone" para comenzar.',
        addButton: 'Agregar Drone',
    },
    buffalo: {
        title: 'Línea Buffalo',
        description: 'Gestionar motores y acoplados de la Línea Buffalo en el sistema',
        empty: 'No hay elementos de Línea Buffalo registrados. Haga clic en "Agregar" para comenzar.',
        addButton: 'Agregar Elemento Buffalo',
    },
    powerCitros: {
        title: 'Power Citros',
        description: 'Gestionar productos Power Citros — ultra limpiador desengrasante de base cítrica',
        empty: 'No hay productos Power Citros registrados. Haga clic en "Agregar" para comenzar.',
        addButton: 'Agregar Producto Power Citros',
    },
    parts: {
        title: 'Piezas y Accesorios',
        description: 'Gestionar las piezas y accesorios en el sistema',
        empty: 'No hay piezas o accesorios registrados. Haga clic en "Agregar" para comenzar.',
        addButton: 'Agregar Pieza/Accesorio',
    },
    theme: {
        toggle: 'Cambiar tema',
        light: 'Tema claro',
        dark: 'Tema oscuro',
        system: 'Tema del sistema',
    },
};
//# sourceMappingURL=admin.js.map